import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/Vertical_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-a1a0d8ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "select-workspace" }
const _hoisted_2 = { class: "container h-100" }
const _hoisted_3 = { class: "row h-100 justify-content-center align-items-center" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = {
  class: "card workspaces-panel",
  style: {}
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "100",
  width: "100%",
  class: "card-img-top",
  alt: "Smace"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Select a workspace"),
  /*#__PURE__*/_createElementVNode("p", { class: "card-text" }, "You are already invited to work in the following workspaces:")
], -1))
const _hoisted_8 = { class: "list-group list-group-flush" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "card-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_feather_icon = _resolveComponent("feather-icon")!
  const _component_AddWorkspaceModal = _resolveComponent("AddWorkspaceModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspaces, (workspace) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "list-group-item cursor-pointzer",
                  key: workspace.workspaceId,
                  onClick: ($event: any) => (_ctx.selectWorkspace(workspace))
                }, [
                  _createTextVNode(_toDisplayString(workspace.name) + " ", 1),
                  _createVNode(_component_feather_icon, {
                    type: "arrow-right",
                    class: "cursor-pointer float-end",
                    size: "18"
                  })
                ], 8, _hoisted_9))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("a", {
                href: "#",
                class: "card-link btn btn-primary float-end",
                "data-bs-toggle": "modal",
                "data-bs-target": "#addWorkspaceModal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
              }, "Add Workspace ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_AddWorkspaceModal, { onReload: _ctx.load }, null, 8, ["onReload"])
  ]))
}